import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AcademyHero from "./components/AcademyHero";
import AcademyOverview from "./components/AcademyOverview";
import WhoItsFor from "./components/WhoItsFor";
import WhatYouLearn from "./components/WhatYouLearn";
import LearningFormats from "./components/LearningFormats";
import WhyChooseUs from "./components/WhyChooseUs";
import HowItWorks from "./components/HowItWorks";
import Outcomes from "./components/Outcomes";
import AcademyFAQ from "./components/AcademyFAQ";
import AcademyApplyForm from "./components/AcademyApplyForm";

export default function TradingAcademyPage() {
  return (
    <div className="font-['Inter']">
      <Navbar />
      <AcademyHero />
      <AcademyOverview />
      <WhoItsFor />
      <WhatYouLearn />
      <LearningFormats />
      <WhyChooseUs />
      <HowItWorks />
      <Outcomes />
      <AcademyFAQ />
      <AcademyApplyForm />
      <Footer />
    </div>
  );
}
